import { V3PopupComponent } from "#components";
import { V3ModalComponent } from "#components";
import { GoogleAnalytics } from "~/google_analytics/events";
import { EventParameter } from "~/google_analytics/events.enum";

export const useValidateDeliveryAddress = () => {
  const location = useLocation();
  const checkout = useCheckout();
  const cart = useCart();
  const slideover = useSlideover();
  const modal = useModal();
  const route = useRoute();
  const { isMobile } = useDevice();
  const { gtag } = useGtag();
    const auth = useAuth();
      const isAuthenticated = auth && auth.access_token;
      const userData = isAuthenticated ? {
        user_name: auth.user.first_name,
        user_phone: auth.user.phone,
        user_email: auth.user.email,
      } : {
        user_name: null,
        user_phone: null,
        user_email: null
      };

  const validateDeliveryAddress = async (address: any) => {
   
    const isSame =
        Number(location.area_code) === Number(address.area_code) &&
        (location.city?.name ?? '').toLowerCase() === (address.city ?? '').toLowerCase() &&
        (location.state?.name ?? '').toLowerCase() === (address.state ?? '').toLowerCase();
    
    const formatted_address = `${address.door} ${address.building}, ${address.locality}, ${address.city}, ${address.area_code}, ${address.state}`
    const data = {
      name: address.contact.name,
      phone: address.contact.phone,
      email: address.contact.email,
      address_line1: address.door,
      address_line2: address.building,
      address_line3: address.locality,
      area_code: address.area_code,
      city: address.city,
      state: address.state,
      formatted_address: formatted_address,
      label: address.label,
      address_id: address.id
    };

    GoogleAnalytics.cta({
      [EventParameter.CTA_NAME]: "select_saved_address"
    });

    if (isSame) {

      await Promise.all([
        checkout.setSelectedAddress(data),
        checkout.setDeliveryAddress(data)
      ]);
      // await navigateTo({ path: "/checkout", query: { addr: route.query.addr || 1 }, replace: true });
      navigateTo({ path: "/cart", query: { addr: 0 } })
    } else {
      console.log("isMobile", isMobile)
      const popup = isMobile ? slideover : modal;
      popup.open(isMobile ? V3PopupComponent : V3ModalComponent, {
        component: "addresschange",
        onSuccess: async () => {
          await location.setAddress(data);
          await location.setCityCode(data.city);
          await Promise.all([
            checkout.setDeliveryAddress(data),
            checkout.setSelectedAddress(data)
          ]);
          popup.close();
          setTimeout(() => {
            navigateTo({ path: "/cart", query: { addr: 0 } }, { replace: true });
            cart.fetchQuote();
          }, 100);
        },
        onClose: popup.close,
      });
    }
  };

  return {
    validateDeliveryAddress
  };
};
